import React, { useState } from 'react';

const ArchiveConfirm = ({ orgName }) => {
    const [archiveClicked, setArchiveClicked] = useState(false); // Archive button state

    const buttonStyle = {
        display: 'block',
        width: '100%',
        padding: '10px',
        margin: '10px 0',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: 'bold',
    };

    const archiveButtonStyle = {
        ...buttonStyle,
        backgroundColor: archiveClicked ? 'white' : '#f0ad4e', // Invert color on click
        color: archiveClicked ? '#f0ad4e' : 'white',
        border: `2px solid #f0ad4e`, // Add a border
    };

    const confirmWindowStyle = {
        width: '100%',
        marginTop: '10px',
        padding: '15px',
        borderRadius: '5px',
        backgroundColor: '#f9f9f9',
        border: `2px solid #f0ad4e`, // Archive outline color
        textAlign: 'center',
    };

    const textStyle = {
        fontSize: '16px',
        fontWeight: 'bold',
        marginBottom: '10px',
    };

    const handleArchiveClick = () => {
        setArchiveClicked(!archiveClicked);
    };

    return (
        <>
            <button style={archiveButtonStyle} onClick={handleArchiveClick}>
                Archive
            </button>
            {archiveClicked && (
                <div style={confirmWindowStyle}>
                    <p style={textStyle}>Are you sure you want to archive {orgName}?</p>
                    <button className="btn btn-success" style={{ marginRight: '10px' }}>Yes</button>
                    <button className="btn btn-secondary" onClick={handleArchiveClick}>No</button>
                </div>
            )}
        </>
    );
};

export default ArchiveConfirm;
